var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "DialogRePortCalls__Component" }, [
    _c("div", { staticClass: "modal-card" }, [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [_vm._v("קריאות ריפורט")]),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        })
      ]),
      _c(
        "section",
        { staticClass: "modal-card-body" },
        [
          _vm.calls.length
            ? _c(
                "b-table",
                {
                  attrs: {
                    data: _vm.calls,
                    detailed: "",
                    "detail-key": "Id",
                    "show-detail-icon": true,
                    "opened-detailed": _vm.openedDetails,
                    narrowed: "",
                    striped: ""
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "detail",
                        fn: function(props) {
                          return [
                            _c("div", { staticClass: "payloads" }, [
                              props.row.ErrorMessage
                                ? _c("div", { staticClass: "payload" }, [
                                    _c("div", { staticClass: "payload-head" }, [
                                      _c(
                                        "span",
                                        { staticClass: "payload-title" },
                                        [_vm._v("שגיאה")]
                                      )
                                    ]),
                                    _c("pre", { staticClass: "ltr error" }, [
                                      _vm._v(_vm._s(props.row.ErrorMessage))
                                    ])
                                  ])
                                : _vm._e(),
                              _c("div", { staticClass: "payload" }, [
                                _c(
                                  "div",
                                  { staticClass: "payload-head" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "payload-title" },
                                      [_vm._v("בקשה")]
                                    ),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { size: "is-small" },
                                        on: {
                                          click: function($event) {
                                            return _vm.copy(props.row.Request)
                                          }
                                        }
                                      },
                                      [_vm._v("העתק")]
                                    )
                                  ],
                                  1
                                ),
                                _c("pre", { staticClass: "ltr" }, [
                                  _vm._v(_vm._s(_vm.pretty(props.row.Request)))
                                ])
                              ]),
                              _c("div", { staticClass: "payload" }, [
                                _c(
                                  "div",
                                  { staticClass: "payload-head" },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "payload-title" },
                                      [_vm._v("תשובה")]
                                    ),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { size: "is-small" },
                                        on: {
                                          click: function($event) {
                                            return _vm.copy(props.row.Response)
                                          }
                                        }
                                      },
                                      [_vm._v("העתק")]
                                    )
                                  ],
                                  1
                                ),
                                _c("pre", { staticClass: "ltr" }, [
                                  _vm._v(_vm._s(_vm.pretty(props.row.Response)))
                                ])
                              ]),
                              props.row.LogFileName
                                ? _c("div", { staticClass: "log-file ltr" }, [
                                    _vm._v(
                                      " log: " +
                                        _vm._s(props.row.LogFileName) +
                                        " "
                                    )
                                  ])
                                : _vm._e()
                            ])
                          ]
                        }
                      }
                    ],
                    null,
                    false,
                    578339561
                  )
                },
                [
                  _c("b-table-column", {
                    attrs: { field: "StartTime", label: "זמן" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(props) {
                            return [
                              _c("span", { staticClass: "ltr" }, [
                                _vm._v(
                                  _vm._s(_vm.formatTime(props.row.StartTime))
                                )
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2286846536
                    )
                  }),
                  _c("b-table-column", {
                    attrs: { field: "Call", label: "קריאה" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(props) {
                            return [
                              _c("span", { staticClass: "ltr" }, [
                                _vm._v(
                                  _vm._s(_vm.shortCallName(props.row.Call))
                                )
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1023467518
                    )
                  }),
                  _c("b-table-column", {
                    attrs: { field: "IsSuccessful", label: "תקשורת" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(props) {
                            return [
                              _c(
                                "b-tag",
                                {
                                  attrs: {
                                    type: props.row.IsSuccessful
                                      ? "is-success"
                                      : "is-danger"
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        props.row.IsSuccessful ? "תקין" : "נכשל"
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2592026234
                    )
                  }),
                  _c("b-table-column", {
                    attrs: { field: "HttpStatusCode", label: "סטטוס" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(props) {
                            return [
                              _c("span", { staticClass: "ltr" }, [
                                _vm._v(_vm._s(props.row.HttpStatusCode))
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2474829931
                    )
                  }),
                  _c("b-table-column", {
                    attrs: { field: "DurationInSeconds", label: "משך (שניות)" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(props) {
                            return [
                              _c("span", { staticClass: "ltr" }, [
                                _vm._v(
                                  _vm._s(props.row.DurationInSeconds.toFixed(1))
                                )
                              ])
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2956108483
                    )
                  }),
                  _c("b-table-column", {
                    attrs: { field: "RunId", label: "מזהה ריצה" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(props) {
                            return [
                              _c(
                                "span",
                                {
                                  staticClass: "ltr run-id",
                                  attrs: { title: props.row.RunId }
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.shortRunId(props.row.RunId))
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1015721146
                    )
                  })
                ],
                1
              )
            : _c("h1", [_vm._v("לא נמצאו קריאות עבור דוח זה")])
        ],
        1
      ),
      _c(
        "footer",
        { staticClass: "modal-card-foot" },
        [
          _c("b-button", {
            attrs: { label: "סגור" },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }